// Free invite editor (Canva-style): background image + editable text and pictures,
// watermarked download, paid "remove watermark" adds the design to cart with the layout attached.
// Layout positions are fractions of the image (x, y = centre; w, size = share of width)
// so the same layout works at any resolution.
(() => {
  const root = document.querySelector('[data-invite-editor]');
  if (!root || !window.fabric) return;
  const { Canvas, FabricImage, Textbox } = window.fabric;
  const cfg = JSON.parse(root.querySelector('[data-invite-config]').textContent);
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => root.querySelectorAll(sel);
  const storeKey = `vc-invite:${cfg.productId}`;
  const isPhone = () => matchMedia('(max-width: 749px)').matches;
  // Inside the mobile app's WebView: the app saves/shares the image and owns the cart.
  const app = window.ReactNativeWebView;
  const toApp = (msg) => app.postMessage(JSON.stringify(msg));
  const DEFAULT_LAYOUT = [
    { text: 'Rahul\n&\nPriya', x: 0.5, y: 0.38, w: 0.8, size: 0.1, font: 'Great Vibes', color: '#8B1A2B' },
    { text: 'request the pleasure of your company', x: 0.5, y: 0.55, w: 0.75, size: 0.035, font: 'Lora', color: '#333333' },
    { text: '12 December 2026 · 7 PM\nThe Grand Palace, Jaipur', x: 0.5, y: 0.68, w: 0.8, size: 0.04, font: 'Lora', color: '#333333' },
  ];
  const ALIGN_ICONS = { left: 'M4 6h16M4 12h10M4 18h16', center: 'M4 6h16M7 12h10M4 18h16', right: 'M4 6h16M10 12h10M4 18h16' };
  const TOOL_SHEETS = ['font', 'size', 'color', 'styles'];

  let canvas, W, H, zoomPct = 100;
  let history = [], pos = -1, renderId = 0;

  // Canva-like selection: white round handles, brand-coloured frame.
  const handles = {
    originX: 'center', originY: 'center', borderColor: '#8B1A2B', borderScaleFactor: 2, padding: 4,
    cornerStyle: 'circle', cornerColor: '#ffffff', cornerStrokeColor: '#8B1A2B', transparentCorners: false,
    cornerSize: 14, touchCornerSize: 34,
  };
  // Bare file names are theme assets; anything with a slash is a full URL (e.g. Shopify Files).
  // ponytail: no ?v= on these, so a changed asset needs a new file name to beat the CDN cache.
  const srcUrl = (s) => (s.includes('/') ? s : cfg.assetBase + s);
  const fontReady = (family, weight = 'normal') => document.fonts.load(`${weight} 40px "${family}"`).catch(() => {});
  const isBold = (o) => o.fontWeight === 'bold' || +o.fontWeight >= 600;

  // Rotate handle under the object, like Canva, instead of on top.
  // Text keeps corners + side handles (width); pictures keep corners only (no stretching).
  function styleControls(o) {
    const r = o.controls?.mtr;
    if (r) { r.y = 0.5; r.offsetY = 30; }
    o.setControlsVisibility(o instanceof Textbox ? { mt: false, mb: false } : { mt: false, mb: false, ml: false, mr: false });
    return o;
  }

  // w/h default to the open design; previews pass their own size.
  function makeText(t, w = W, h = H) {
    return styleControls(new Textbox(t.text, {
      ...handles, left: t.x * w, top: t.y * h, angle: t.angle || 0,
      width: t.w * w, fontSize: t.size * w, fontFamily: t.font, fill: t.color || '#333333', fontWeight: t.weight || 'normal',
      textAlign: t.align || 'center', lineHeight: t.lh || 1.15, charSpacing: t.spacing || 0,
    }));
  }

  async function makeImage(t, w = W, h = H) {
    const img = await FabricImage.fromURL(srcUrl(t.src), { crossOrigin: 'anonymous' }, { ...handles, angle: t.angle || 0 });
    img.scaleToWidth(t.w * w);
    img.set({ left: t.x * w, top: t.y * h, vcSrc: t.src });
    return styleControls(img);
  }

  const make = (t, w, h) => (t.src ? makeImage(t, w, h).catch(() => null) : makeText(t, w, h));

  // One object as plain data (also what goes into the order).
  function toItem(o) {
    const r = (n) => +n.toFixed(4);
    const c = o.getCenterPoint();
    const base = { x: r(c.x / W), y: r(c.y / H), w: r((o.width * o.scaleX) / W), angle: Math.round(o.angle) || undefined };
    if (o.vcSrc) return { src: o.vcSrc, ...base };
    return {
      text: o.text, ...base, size: r((o.fontSize * o.scaleY) / W), font: o.fontFamily, color: o.fill,
      weight: o.fontWeight === 'normal' ? undefined : o.fontWeight, align: o.textAlign,
      lh: o.lineHeight === 1.15 ? undefined : o.lineHeight, spacing: o.charSpacing || undefined,
    };
  }
  const layout = () => canvas.getObjects().map(toItem);

  async function render(items) {
    const id = ++renderId;
    const objs = await Promise.all(items.map((t) => make(t)));
    if (id !== renderId) return; // a newer undo/redo finished loading first
    canvas.discardActiveObject();
    canvas.remove(...canvas.getObjects());
    canvas.add(...objs.filter(Boolean));
    canvas.requestRenderAll();
    syncTools();
  }

  // ---- history (undo/redo) + autosave ----
  function commit() {
    const snap = JSON.stringify(layout());
    if (snap === history[pos]) return;
    history = history.slice(Math.max(0, pos - 59), pos + 1);
    history.push(snap);
    pos = history.length - 1;
    try { localStorage.setItem(storeKey, snap); } catch {}
    syncHistory();
  }

  async function step(dir) {
    const next = pos + dir;
    if (next < 0 || next >= history.length) return;
    pos = next;
    try { localStorage.setItem(storeKey, history[pos]); } catch {}
    syncHistory();
    await render(JSON.parse(history[pos]));
  }

  function syncHistory() {
    $('[data-act=undo]').disabled = pos <= 0;
    $('[data-act=redo]').disabled = pos >= history.length - 1;
  }

  // ---- watermark: small logo badge in the bottom-right corner, drawn on top and not selectable ----
  async function watermark() {
    const logo = (await FabricImage.fromURL(cfg.watermark, { crossOrigin: 'anonymous' })).getElement();
    const el = document.createElement('canvas');
    el.width = W; el.height = H;
    const ctx = el.getContext('2d');
    const lw = W * 0.2, lh = (lw * logo.height) / logo.width, pad = lw * 0.08, m = W * 0.03;
    const x = W - m - lw - pad * 2, y = H - m - lh - pad * 2;
    ctx.fillStyle = 'rgba(255,255,255,.85)';
    ctx.beginPath();
    ctx.roundRect(x, y, lw + pad * 2, lh + pad * 2, pad);
    ctx.fill();
    ctx.drawImage(logo, x + pad, y + pad, lw, lh);
    return new FabricImage(el, { originX: 'left', originY: 'top' });
  }

  function fit() {
    const stage = $('[data-stage]');
    const cs = getComputedStyle(stage);
    const padX = parseFloat(cs.paddingLeft) * 2, padY = parseFloat(cs.paddingTop) * 2;
    const base = Math.min((stage.clientWidth - padX) / W, (stage.clientHeight - padY) / H);
    const z = Math.max(0.05, base * (zoomPct / 100));
    canvas.setDimensions({ width: W * z, height: H * z });
    canvas.setZoom(z);
    canvas.requestRenderAll();
  }

  // ---- toolbars + sheets follow the selection ----
  function syncTools() {
    const o = canvas.getActiveObject();
    root.classList.toggle('has-sel', !!o);
    root.classList.toggle('is-img', !!o?.vcSrc);
    $('[data-tools]').hidden = !o;
    $('[data-text-tools]').hidden = !o || !!o.vcSrc;
    if (!o || o.vcSrc) {
      if (TOOL_SHEETS.includes(openName())) openTab(null);
      return;
    }
    const size = Math.round((o.fontSize * o.scaleY * 1000) / W);
    $$('[data-f=font]').forEach((el) => { el.value = o.fontFamily; });
    $$('[data-f=size], [data-f=size-range]').forEach((el) => { el.value = size; });
    $('[data-size-out]').textContent = size;
    $$('[data-f=color]').forEach((el) => { el.value = o.fill; });
    $$('[data-swatch]').forEach((el) => { el.style.color = o.fill; });
    $$('[data-color]').forEach((el) => el.classList.toggle('is-on', el.dataset.color.toLowerCase() === String(o.fill).toLowerCase()));
    $$('[data-set-font]').forEach((el) => el.classList.toggle('is-on', el.dataset.setFont === o.fontFamily));
    $$('[data-act=bold]').forEach((el) => el.classList.toggle('is-on', isBold(o)));
    $$('[data-align]').forEach((el) => el.classList.toggle('is-on', el.dataset.align === o.textAlign));
    $('[data-align-icon] path').setAttribute('d', ALIGN_ICONS[o.textAlign] || ALIGN_ICONS.center);
    $('[data-f=spacing]').value = o.charSpacing;
    $('[data-f=lh]').value = o.lineHeight;
  }

  function setProp(key, val, save = true) {
    const o = canvas.getActiveObject();
    if (!o || o.vcSrc) return;
    if (key === 'size') o.set({ fontSize: (Math.max(5, val) * W) / 1000 / o.scaleY });
    else o.set({ [key]: val });
    o.initDimensions?.();
    o.setCoords();
    canvas.requestRenderAll();
    syncTools();
    if (save) commit();
  }

  async function setFont(family) {
    await fontReady(family, canvas.getActiveObject()?.fontWeight);
    setProp('fontFamily', family);
  }

  function select(o) {
    canvas.setActiveObject(o);
    canvas.requestRenderAll();
    syncTools();
    commit();
  }

  async function addItem(t) {
    const o = await make({ x: 0.5, y: 0.5, color: '#333333', ...t });
    if (!o) return;
    canvas.add(o);
    select(o);
    if (isPhone()) openTab(null);
  }

  function removeSelected() {
    const o = canvas.getActiveObject();
    if (!o || o.isEditing) return;
    canvas.remove(o);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    syncTools();
    commit();
  }

  async function duplicate() {
    const o = canvas.getActiveObject();
    if (!o) return;
    const t = toItem(o);
    const copy = await make({ ...t, x: Math.min(t.x + 0.03, 0.95), y: Math.min(t.y + 0.03, 0.95) });
    if (copy) { canvas.add(copy); select(copy); }
  }

  function editText() {
    const o = canvas.getActiveObject();
    if (!o || o.vcSrc) return;
    openTab(null);
    o.enterEditing();
    o.selectAll();
    canvas.requestRenderAll();
  }

  // ---- side panel / bottom sheet ----
  const openName = () => ($('[data-panel]').hidden ? null : $('[data-tab-panel]:not([hidden])')?.dataset.tabPanel);

  function openTab(name) {
    const show = name && openName() !== name;
    $('[data-panel]').hidden = !show;
    root.classList.toggle('sheet-open', !!show);
    $$('[data-tab]').forEach((b) => b.classList.toggle('is-active', show && b.dataset.tab === name));
    $$('[data-tab-panel]').forEach((s) => { s.hidden = !show || s.dataset.tabPanel !== name; });
  }

  // ---- output ----
  function download() {
    canvas.getActiveObject()?.exitEditing?.();
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    syncTools();
    const data = canvas.toDataURL({ format: 'jpeg', quality: 0.92, multiplier: 1 / canvas.getZoom() });
    if (app) return toApp({ type: 'download', data, filename: `${cfg.handle}-invite.jpg` });
    const a = document.createElement('a');
    a.href = data;
    a.download = `${cfg.handle}-invite.jpg`;
    a.click();
  }

  async function buyClean(btn) {
    const items = layout();
    const properties = {
      'Invite text': items.filter((t) => t.text).map((t) => t.text.replace(/\n/g, ' ')).join(' | '),
      _invite_layout: JSON.stringify(items),
    };
    if (app) return toApp({ type: 'buy', variantId: cfg.variantId, properties });
    btn.disabled = true;
    try {
      const res = await fetch(`${cfg.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1, properties }] }),
      });
      if (!res.ok) throw new Error((await res.json()).description);
      location.href = '/checkout';
    } catch (e) {
      alert(e.message || 'Could not add to cart. Please try again.');
      btn.disabled = false;
    }
  }

  const ACTIONS = {
    undo: () => step(-1),
    redo: () => step(1),
    download,
    buy: (b) => buyClean(b),
    'buy-now': (b) => buyClean(b),
    premium: () => openTab('premium'),
    close: () => openTab(null),
    done: () => { canvas.discardActiveObject(); canvas.requestRenderAll(); syncTools(); },
    edit: editText,
    duplicate,
    delete: removeSelected,
    bold: async () => {
      const o = canvas.getActiveObject();
      if (!o || o.vcSrc) return;
      const w = isBold(o) ? 'normal' : 'bold';
      await fontReady(o.fontFamily, w);
      setProp('fontWeight', w);
    },
    align: () => {
      const order = ['left', 'center', 'right'];
      setProp('textAlign', order[(order.indexOf(canvas.getActiveObject()?.textAlign) + 1) % 3]);
    },
    smaller: () => nudge(-1),
    bigger: () => nudge(1),
    reset: async () => {
      if (!confirm('Start again from the original design?')) return;
      await render(cfg.layout || DEFAULT_LAYOUT);
      commit();
    },
  };

  function nudge(dir) {
    const v = +$('[data-f=size]').value;
    setProp('size', v + dir * Math.max(1, Math.round(v * 0.08)));
  }

  async function start() {
    const fonts = cfg.fonts.map((f) => f.split(':')[0]);
    await Promise.all(fonts.flatMap((f) => ['normal', '600', 'bold'].map((w) => fontReady(f, w))));
    const bg = await FabricImage.fromURL(cfg.image, { crossOrigin: 'anonymous' }, { originX: 'left', originY: 'top' });
    W = bg.width; H = bg.height;
    canvas = new Canvas($('[data-canvas]'), { width: W, height: H, preserveObjectStacking: true, selection: false });
    canvas.backgroundImage = bg;
    canvas.overlayImage = await watermark();
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(storeKey)); } catch {}
    // Ignore a broken saved copy (e.g. from an older editor version) and start from the design.
    const ok = (t) => [t.x, t.y, t.w].every(Number.isFinite) && t.w > 0 && (t.src || t.size > 0.005);
    if (!Array.isArray(saved) || !saved.length || !saved.every(ok)) saved = null;
    await render(saved || cfg.layout || DEFAULT_LAYOUT);
    commit();
    if (!isPhone()) openTab('designs');
    const placeUnderHeader = () => root.style.setProperty('--ie-top', `${root.getBoundingClientRect().top + scrollY}px`);
    placeUnderHeader();
    addEventListener('resize', placeUnderHeader);
    fit();
    root.classList.add('is-ready');

    canvas.on({
      'selection:created': syncTools, 'selection:updated': syncTools, 'selection:cleared': syncTools,
      'object:modified': () => { syncTools(); commit(); }, 'text:editing:exited': commit,
    });
    new ResizeObserver(fit).observe($('[data-stage]'));

    // One click handler for every button: data-act, data-tab, data-add-*, data-set-font, data-color, data-align.
    root.addEventListener('click', async (e) => {
      const b = e.target.closest('button, [data-act]');
      if (!b || b.disabled) return;
      const d = b.dataset;
      if (d.act === 'buy' && isPhone()) return openTab('premium');
      if (d.act) return ACTIONS[d.act]?.(b);
      if (d.tab) return openTab(d.tab);
      if (d.setFont) return setFont(d.setFont);
      if (d.color) return setProp('fill', d.color);
      if (d.align) return setProp('textAlign', d.align);
      if (d.addImage) return addItem({ src: d.addImage, w: 0.25 });
      if (d.addText) {
        const t = JSON.parse(d.addText);
        await fontReady(t.font, t.weight);
        addItem(t);
      }
    });

    $('select[data-f=font]').addEventListener('change', (e) => setFont(e.target.value));
    $('[data-f=size]').addEventListener('change', (e) => setProp('size', +e.target.value));
    $('[data-f=size-range]').addEventListener('input', (e) => setProp('size', +e.target.value, false));
    $('[data-f=spacing]').addEventListener('input', (e) => setProp('charSpacing', +e.target.value, false));
    $('[data-f=lh]').addEventListener('input', (e) => setProp('lineHeight', +e.target.value, false));
    $$('[data-f=color]').forEach((el) => el.addEventListener('input', (e) => setProp('fill', e.target.value, false)));
    $$('[data-f=size-range], [data-f=spacing], [data-f=lh], [data-f=color]').forEach((el) => el.addEventListener('change', commit));
    $('[data-f=zoom]').addEventListener('input', (e) => {
      zoomPct = +e.target.value;
      $('[data-zoom-label]').textContent = `${zoomPct}%`;
      fit();
    });
    // Designer mode (?designer=1): arrange the sample text, then paste the copied layout into the
    // product's "Invite layout" metafield. Harmless for customers; it only copies text positions.
    if (new URLSearchParams(location.search).has('designer')) {
      const btn = Object.assign(document.createElement('button'), { type: 'button', className: 'ie-btn ie-btn--light', textContent: 'Copy layout' });
      btn.addEventListener('click', async () => {
        await navigator.clipboard.writeText(JSON.stringify(layout()));
        btn.textContent = 'Copied ✓';
        setTimeout(() => { btn.textContent = 'Copy layout'; }, 2000);
      });
      $('.ie-top .ie-spacer').after(btn);
    }
    $$('[data-search]').forEach((input) => input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      input.nextElementSibling.querySelectorAll('[data-name]').forEach((el) => { el.hidden = q && !el.dataset.name.includes(q); });
    }));

    document.addEventListener('keydown', (e) => {
      if (canvas.getActiveObject()?.isEditing || /INPUT|SELECT|TEXTAREA/.test(e.target.tagName)) return;
      const mod = e.ctrlKey || e.metaKey;
      if (mod && e.key.toLowerCase() === 'z') { e.preventDefault(); step(e.shiftKey ? 1 : -1); }
      else if (mod && e.key.toLowerCase() === 'y') { e.preventDefault(); step(1); }
      else if (e.key === 'Delete' || e.key === 'Backspace') removeSelected();
    });
  }

  start().catch((e) => {
    console.error(e);
    $('[data-stage]').textContent = 'Sorry, this design could not be loaded. Please refresh the page.';
  });
})();
